// import casl from "./casl";
// import mitt from "./mitt";
import dayjs from "./dayjs";
import toast from "./toast";
// import quill from "./quill";
// import tinymce from "./tinymce";
import filepond from "./filepond";
import FontAwesome from "./fortawesome";
import GlobalComponents from "./components";
import VueSelect from "./vue-select";

export default {
    install: (app, options) => {
        // app.use(casl);
        // app.use(mitt);
        app.use(dayjs);
        app.use(toast);
        // app.use(quill);
        // app.use(tinymce);
        app.use(filepond);
        app.use(FontAwesome);
        app.use(GlobalComponents);
        app.use(VueSelect);
    }
}
